import { render } from "./NDropdownItemDivider.vue?vue&type=template&id=83d45d50&ts=true"
import script from "./NDropdownItemDivider.vue?vue&type=script&lang=ts"
export * from "./NDropdownItemDivider.vue?vue&type=script&lang=ts"

import "./NDropdownItemDivider.vue?vue&type=style&index=0&id=83d45d50&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__